export default __webpack_public_path__ + "static/media/homeImageBlue.ccedbf74.jpeg";